import rego from "refractor/rego";
export default rego;